/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/motherhood/components/standalone/ArticleHeader/theme';

export const ArticleHeaderTheme = theme;
